/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ObjectType from './ObjectType';
import PropertySetter from './PropertySetter';
import MoserObject from './MoserObject';
import EditModeType from './EditModeType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // set
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (static) // fromValue

/**
 * This class provides a set of static utility APIs for edit mode operations. This class will be translated to JavaScript
 * @author  alan-tran
 */
export default class EditModeUtils extends BaseMoserObject{

	/**
	 * set editMode for all ObjectType(s) in the module. node is of type MoserObject, because some collections that contain instances of ObjectType, but those collections are instances of MoserObject.
	 * @param {MoserObject} node
	 * @param {EditModeType} mode
	 */
	static setEditMode$0(node, mode) {
		EditModeUtils.setEditMode$1(node, mode, true);
	}

	static setEditMode$1(node, mode, override) {
		if (node instanceof ObjectType) {
			if (override) {
				(node).setEditMode(mode);
			} else {
				PropertySetter.set(node, 161, mode, false);
			}
		}
		var featureList = node.getFeatureList(null);
		for (var __i_enFor0 = 0, __exp_enFor0 = featureList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var feature = __exp_enFor0[__i_enFor0];
			var obj = node.basicGet(feature.getFeatureID());
			if (obj == null) {
				continue;
			}
			if (feature.getIsList()) {
				for (var __i_enFor1 = 0, __exp_enFor1 = obj, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var child = __exp_enFor1[__i_enFor1];
					if (child instanceof MoserObject) {
						EditModeUtils.setEditMode$1(child, mode, override);
					}
				}
			} else if (obj instanceof MoserObject) {
				EditModeUtils.setEditMode$1(obj, mode, override);
			}
		}
	}

	/**
	 * get editMode from string. returns enum type based on string value. returns null if editMode is null or invalid.
	 * @param {String} editMode 	string value
	 */
	static getEditModeTypeFromValue(editMode) {
		try {
			return EditModeType.fromValue(editMode);
		} catch (e) {
			throw e;
		}

	}

	static setEditMode(a0, a1, a2) {
		var args = arguments;
		if (args.length == 2) {
			return EditModeUtils.setEditMode$0(a0, a1);
		}
		return EditModeUtils.setEditMode$1(a0, a1, a2);
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/EditModeUtils.js